// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__NazlD","bigColWidth":"Table_bigColWidth__1omjL","biggerColWidth":"Table_biggerColWidth__H951A","row":"Table_row__2BP0X","col":"Table_col__1zbDZ"};